import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { getDataType } from '@/shared/functions';
import { fontEndConfig } from '@/shared/utils';
const initState = {
    pageIndex: 1,
    pageSize: 9,
    total: 0,
    searchData: {},
    activeKey: '5',
    tableData: [],
    tabList: [
        {
            label: '投标中',
            key: '5',
            num: fontEndConfig.noValueReplace,
        },
        {
            label: '竞拍中',
            key: '2',
            num: fontEndConfig.noValueReplace,
        },
        {
            label: '已结束',
            key: '3',
            num: fontEndConfig.noValueReplace,
        },
    ],
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        // 获取tabs数据
        loadTabsData(payload, { state }) {
            const { searchData } = state;
            Api.auction.roundMonitorTabDataCount(Object.assign({}, searchData))
                .then((_r) => {
                this.SET_TABLELIST_NUM(_r);
            });
        },
        // 获取卡片列表数据
        load(payload, { state }) {
            const { searchData, pageIndex, pageSize, activeKey } = state;
            Api.auction.getBidSession(Object.assign(Object.assign({}, searchData), { pageIndex,
                pageSize, roundStatus: activeKey }))
                .then((res) => {
                this.SET_STATE({
                    tableData: res.items || [],
                    total: res.totalNumber || 0,
                });
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                state[key] = payload[key];
            });
        },
        SET_TABLELIST_NUM(state, payload) {
            const dealPayload = getDataType(payload) === 'Array' ? payload : [];
            state.tabList.forEach((item) => {
                const index = dealPayload.findIndex((v) => String(v.status) === item.key);
                item.num = index !== -1 ? dealPayload[index].roundListCount : 0;
            });
        },
        SET_SEARCHDATA(state, payload) {
            const { type, value } = payload;
            switch (type) {
                case 'roundName':
                    state.searchData[type] = value;
                    state.searchData.roundCode = '';
                    break;
                case 'roundCode':
                    state.searchData[type] = value;
                    state.searchData.roundName = '';
                case 'time':
                    if (getDataType(value) === 'Array') {
                        const timeValue = value.map((m) => (m.format('YYYY-MM-DD')));
                        state.searchData.queryStartDate = timeValue[0];
                        state.searchData.queryEndDate = timeValue[1];
                    }
                    break;
                default:
                    state.searchData[type] = value;
            }
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageIndex = payload;
        },
    },
});
